import { DisinvestmentStrategyClient } from "../../../../../Wrap/Api/Instruction/DisinvestmentStrategy";
import { DisinvestmentStrategyType } from "../../../../../Wrap/Constants/Enums/Client/DisinvestmentStrategyType";
import { DisinvestmentStrategyTypeModel } from "../../../../../Wrap/Models/Domains/Instructions/DisinvestmentStrategyTypeModel";

export class DisinvestmentStrategyTypeAction {
    public static getDisinvestmentStrategy(
        instructionId: string,
        callBack?: (val: DisinvestmentStrategyTypeModel) => void
    ): void {
        const client = new DisinvestmentStrategyClient();
        const promise = client.get(instructionId);
        promise.onSuccess((res) => {
            callBack(res);
        });
        promise.onError((err) => {});
    }
}
